/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement } from 'react';

type Props = {
	className?: string;
};

const defaultProps = {
	className: '',
};

const TaskLoader = ({ className }: Props): ReactElement => (
	<div className={className}>
		<div className="loader-wrapper">
			<img src={`${process.env.PUBLIC_URL}/images/animated/spinner.svg`} className="image" alt="loader" />
			<p className="text">Loading...</p>
		</div>
	</div>
);

TaskLoader.defaultProps = defaultProps;
export default TaskLoader;
